export const setUserLanguage = (language)=>(prevUser)=>{
        if (!prevUser?.meta?.dbUser) {
            return null;
        }
        return {
            ...prevUser,
            meta: {
                ...prevUser.meta,
                dbUser: {
                    ...prevUser.meta.dbUser,
                    language
                }
            }
        };
    };
